<div>
  {{ data?.initialState?.body }}
</div>
